const DEFAULT_SIZE = 24

export const EditSquare = ({ height = DEFAULT_SIZE, width = DEFAULT_SIZE, color = '#141424', className }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M24.0277 3.61349L29.4431 9.02884L15.391 22H10V16.5622L24.0277 3.61349ZM12 17.4378V20H14.609L23.4369 11.8512L20.8523 9.2665L12 17.4378ZM22.323 7.90886L24.9077 10.4935L26.5569 8.97114L23.9723 6.38648L22.323 7.90886Z'
      fill={color}
    />
    <path d='M4 5H16V7H6V26H26V16.7368H28V28H4V5Z' fill={color} />
  </svg>
)
